module.exports = __webpack_public_path__ + "static/10-3327e13ea840be080373be9494764d18.svg";